import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";

interface CreatePaymentIntentRequest {
  amount?: number;
  customerId?: string;
  paymentMethodId?: string;
  paymentMethodTypes: string[];
  userId?: string;
  discountCode?: string;
  productId?: string;
  isAnnual?: boolean;
  name?: string;
  email?: string;
  IsEventEarlyBird?: boolean;
  isEvent?: boolean;
}

export interface CreatePaymentIntentResponse {
  clientSecret?: string | null;
  customerId?: string;
  paymentMethodId?: string;
  /** Payable amount was zero (e.g. executive member / full discount); no PaymentIntent — complete booking without confirmCardPayment. */
  noPaymentRequired?: boolean;
  amount?: number;
  currency?: string;
  /** When true, payment already succeeded on server; frontend should skip confirmCardPayment. */
  paymentAlreadySucceeded?: boolean;
}

export const useMakePayment = (
  options?: UseMutationOptions<
    CreatePaymentIntentResponse,
    unknown,
    CreatePaymentIntentRequest,
    unknown
  >
) => {
  return useMutation({
    ...options,
    mutationFn: (data: CreatePaymentIntentRequest) =>
      axiosInstance
        .post(getAPIURL("/Payment/create-payment-intent"), data)
        .then((res) => res.data),
  });
};
